module.exports = __webpack_public_path__ + "static/media/hydropneumatic.5f2d6997.svg";